module.exports = {
  instore: `
  @page {
    size: A4;
  }
  #preview {
    width: 210mm;
    background-color: #FFFFFF;
    z-index: 100;
    margin-inline: auto;
  }
  .printTitle {
    text-align: center;
    font-size: 18px;
    letter-spacing: 2px;
  }
  .printCount {
    border: 1px solid #CACACA;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    margin-top: 16px;
  }
  .printCount>div{
    flex:1;
    text-align: center;
  }
  .instore {
    background-color: #FFFFFF;
  }
  .each {
    border: 1px solid #CACACA;
    margin-top: 10px;
    min-height: 85px;
    page-break-inside: avoid;
    page-break-after: auto;
    display: grid;
    grid-template-columns: 1fr 1.2fr 2fr 2fr 1fr 1fr 4fr;
  }
  .each>div:not(:last-child) {
    border-right: 1px solid #CACACA;
  }
  .each>div {
    flex:1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    text-align: start;
    padding: 5px 10px;
    font-size: smaller;
  }`,
  takeout: `
  @page {
    size: A4;
  }
  #preview {
    width: 210mm;
    background-color: #FFFFFF;
    z-index: 100;
    margin-inline: auto;
  }
  .printTitle {
    text-align: center;
    font-size: 18px;
    letter-spacing: 2px;
  }
  .takeout {
    background-color: #FFFFFF;
  }
  .printCount {
    border: 1px solid #CACACA;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    margin-top: 16px;
  }
  .printCount>div{
    flex:1;
    text-align: center;
  }
  .each {
    display: grid;
    grid-template-columns: 1fr 1.2fr 2fr 2fr 1fr 1fr 4fr;
    border: 1px solid #CACACA;
    margin-top: 10px;
    min-height: 85px;
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .each>div:not(:last-child) {
    border-right: 1px solid #CACACA;
  }
  .each>div {
    flex:1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    text-align: start;
    padding: 5px 10px;
    font-size: smaller;
  }`,
  summary: `
  * {
    box-sizing: border-box;
  }
  @page {
    size: A4;
  }
  #preview {
    width: 210mm;
    background-color: #FFFFFF;
    z-index: 100;
    margin-inline: auto;
  }
  .summary {
    background-color: #FFFFFF;
  }
  hr {
    page-break-after: always;
    background: transparent;
    border: none;
  }
  .printTitle {
    text-align: center;
    font-size: 18px;
    letter-spacing: 2px;
  }
  .printCount {
    border: 1px solid #CACACA;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    margin-top: 16px;
  }
  .printCount>div{
    flex:1;
    text-align: center;
  }
  .printBody {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 30px;
  }
  .eachItem {
    display: flex;
    flex-direction: column;
    border: 1px solid #CACACA;
    margin-top: 10px;
    min-height: 85px;
    page-break-inside: avoid;
    page-break-after: auto;
    align-items: center;
    justify-content: flex-start;
  }
  .eachItem>div:nth-child(1) {
    font-size: 20px;
    font-weight: 700;
    padding-block: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #CACACA;
    width: calc(100% - 20px);
  }
  .eachItem>div:not(:first-child) {
    width: 100%;
    padding: 1mm 2mm;
  }
  .eachItem>div:not(:first-child)>div {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-inline: 10px;
    width: 100%;
  }`,
  tickets: `
  @page {
    size: A4;
  }
  .printTitle {
    text-align: center;
    font-size: 18px;
    letter-spacing: 2px;
  }
  .tickets {
    background-color: #FFFFFF;
  }
  .printCount {
    border: 1px solid #CACACA;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    margin-top: 16px;
  }
  .printCount>div{
    flex:1;
    text-align: center;
  }
  .each {
    display: grid;
    grid-template-columns: 2em 1fr 3fr 3fr 1.5fr 2fr 2fr;
    border: 1px solid #CACACA;
    margin-top: 10px;
    min-height: 85px;
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .each>div:not(:last-child) {
    border-right: 1px solid #CACACA;
  }
  .each>div {
    flex:1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    text-align: start;
    padding: 1em 10px;
    font-size: smaller;
  }
  .each>div>hr {
    width: 100%;
    height: 1px;
    background: #CACACA;
    margin: 1em 0;
    border: none;
  }
  `,
  printSheet: `
  @page {
    size: A4;
  }
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100;300;400;500;700;900&family=Roboto:wght@100;300;400;500;700;900&display=swap');
  * {
    box-sizing: border-box;
    font-family: 'Noto Sans TC';
  }
  .printSheet {
    background-color: #FFFFFF;
  }
  .itemsNames {
    max-height: 155mm;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  #preview {
    width: 210mm;
    background-color: #FFFFFF;
    z-index: 100;
    margin-inline: auto;
    position:relative;
  }
  .itemsName {
    font-size: {size}px;
    line-height: 146%;
    font-weight: 700;
    padding-left: 28px;
    text-align: start;
  }
  .itemsName:nth-of-type(n+10) {
    padding-left: calc(28px - 0.5em);
  }
  .singleItemsPrice, .mainItemName {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-inline: 10px;
  }
  .singleItemsPrice>div, .mainItemName>div {
    font-size: 22px;
    font-weight: 700;
  }
  .mainItemName>div:not(:nth-child(1)) {
    white-space: nowrap;
  }
  .mainItem {

  }
  .mainItem>div:nth-child(1) {
    height: 32px;
    background-color: #999999;
    color: #FFFFFF!important;
    text-align: start;
    padding-left: 24px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  table {
    border-collapse: collapse;
    width: 100%;
  }
  tr {
    width: 100%;
  }
  th {
    color: #FFFFFF!important;
    border: none;
    height: 32px;
    white-space: nowrap;
    padding-inline: 10px;
  }
  th:nth-child(1) {
    width: 50%;
    text-align: start;
    padding-left: 18px;
  }
  td {
    font-size: 22px;
    width: fit-content;
  }
  td:nth-child(1) {
    text-align:start;
    width: inherit;
  }
  td:not(:nth-child(1)) {
    white-space: nowrap;
  }
  #preview * {
    color: #5E5E5E;
  }
  .block2 {
    display: grid;
    grid-template-rows: 1fr 127px;
    padding: 6px;
    gap: 6px;
  }
  .block2>div:nth-child(1) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }
  .block2>div:nth-child(1)>div{
    display: grid;
    grid-template-rows: 45px 1fr;
    gap: 6px;
  }
  .block2>div:nth-child(1)>div>div{
    border: 1px solid #5E5E5E;
  }
  .block2>div:nth-child(1)>div>div:nth-child(2){
    min-height: 625px;
  }
  .block2>div:last-child {
    border: 1px solid #5E5E5E;
    text-align: start;
    padding: 8px 16px;
  }
  .page {
    max-height: 277mm;
    page-break-inside: avoid;
    display: grid;
    flex-direction: column;
    gap: 11px;
    grid-template-rows: 200px 1fr 74px;
    background-color: #FFFFFF;
  }
  .page:not(:last-child) {
    page-break-after: always;
  }
  .block2, .block1, .block3 {
    width: 100%;
    border: 3px solid #5E5E5E;
    max-width: 794px;
  }
  .block1 {
    display: grid;
    grid-template-columns: 38% 1fr;
  }
  .block1>div:nth-child(1) {
    border-right: 1px solid #5E5E5E;
    display: grid;
    grid-template-rows: 1fr 1fr;
  }
  .block1>div:nth-child(1)>div:nth-child(1) {
    border-bottom: 1px solid #5E5E5E;
  }
  .block1>div:nth-child(1)>div{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    padding-left: 16px;
    font-size: 20px;
  }
  .block1>div:nth-child(2) {
    border-right: 1px solid #5E5E5E;
    display: grid;
    grid-template-rows: 36px 1fr;
  }
  .block1>div:nth-child(2)>div{
    text-align: start;
  }
  .block1>div:nth-child(2)>div:nth-child(1) {
    background-color: rgb(128, 128, 128);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #FFFFFF;
    padding-inline: 24px;
    font-size: 16px;
    text-align: start;
  }

  .block1>div:nth-child(1)>div>div {
    text-align: start;
    white-space: nowrap;
    font-size: 26px;
  }
  .tables {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    align-items: center;
    justify-content: center;
  }
  .table {
    min-width: 50px;
    width: 70px;
    border-bottom: 1px solid #5E5E5E;
    height: 36px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
  }
  .block3 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .block2 p {
    font-size: 24px;
    padding: 0;
    margin: 0;
  }
  p:nth-child(2) {
    margin-top: .5em;
  }
  .block3>div:nth-child(1) {
    border-right: 1px solid #5E5E5E;
  }
  .block3>div{
    text-align: start;
    padding: 8px 16px;
    font-size: 24px;
  }

  `,
  sheet: `
  @page {
    size: A4;
  }
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100;300;400;500;700;900&family=Roboto:wght@100;300;400;500;700;900&display=swap');
  * {
    box-sizing: border-box;
    font-family: 'Noto Sans TC';
  }
  :root {
    --fonts11: calc(11mm * 0.3);
    --fonts14: calc(14mm * 0.3);
    --fonts16: calc(16mm * 0.3);
    --fonts18: calc(18mm * 0.3);
  }
  #preview {
    position:relative;
    padding: 0;
  }
  hr {
    border-top: 1px dashed #000000;
    margin-block: 2em 1em;
  }
  h2 {
    font-size: var(--fonts18);
    margin: 0;
  }
  .remarkout p {
    font-size: var(--fonts16);
    margin-block: .2em;
  }
  .remarkout {
    padding: 1em;
    border: 1px solid #000000;
    text-align: start;
    margin-bottom: 1em;
  }
  .mainSheet {
    position: relative;
  }
.remarkDetail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: auto;
}
.remarkDetail>div{
  height: 2em;
}
.remark {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2px;
  text-align: start;
}
.sign {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2px;
  text-align: center;
}
.footer {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 0;
  font-size: var(--fonts11);
  height: 3.2em;
}
.footer>div{
  text-align: start;
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
}
.footer span {
  display: inline-flex;
  height: 12mm;
  border-bottom: 1px solid;
  width: fill;
}
.totalprice {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding-inline: 5px;
}
.totalprice>div {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
}
.totalprice>div>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
table.products {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000000;
  line-height: 180%;
  font-size: var(--fonts11);
  height: 81mm;
  border-top: none;
}
table.products thead>tr {
  border-bottom: 1px solid;
}
table.products tfoot>tr {
  border-top: 1px solid;
  height: 0;
}
.productslist tr {
  max-height: 10mm;
}
.productslist td {
  vertical-align: unset;
}
.productslist td {
  text-align: start;
  padding: 2px 8px;
  max-height: 10mm;
}
table.products th {
  line-height: 150%;
  padding-inline: 8px;
}
table.products th:nth-child(2) { width: inherit; text-align: start; }
table.products th:nth-child(4) { width: 3em; text-align: center; padding: 0; }
table.products th:nth-child(5) { width: 5em; text-align: end; }
table.products th:nth-child(6) { width: 5em; text-align: end; }
table.products th:nth-child(7) { width: 18em; text-align: start; }
.productslist td:nth-child(1) { width: 3em; text-align: center; }
.productslist td:nth-child(2) { width: inherit; text-align: start; }
.productslist td:nth-child(3) { width: 4em; text-align: center; }
.productslist td:nth-child(4) { width: 3em; text-align: center; }
.productslist td:nth-child(5) { width: 5em; text-align: end; }
.productslist td:nth-child(6) { width: 5em; text-align: end; }
tr>:not(:first-child) {
  border-left: 1px solid #000000;
}
table.companyInfo {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000000;
  line-height: 180%;
  font-size: var(--fonts11);
  margin-top: 5px;
  height: 16mm;
}
table.companyInfo td>div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #787878;
  max-height: var(--font18);
}
table.companyInfo>tr,
table.companyInfo td {
  height: var(--fonts18);
}
table.companyInfo>tr:last-child {
  border-bottom: 1px solid #000000;
}
table.companyInfo td>div>div.span {
  min-width: 4em;
  width: 4em;
  margin-right: 1em;
  text-align: justify;
  text-align-last: justify!important;
  color: #000000;
}
table.companyInfo td {
  text-align: start;
  padding: 2px 8px;
  width: 50%;
}
.sheet {
  position:relative;
}
.rightBottom {
  position: absolute;
  font-size: var(--fonts11);
  text-align: start;
  bottom: 0;
  right: 0;
}
.rightTop {
  position: absolute;
  font-size: var(--fonts11);
  text-align: start;
  bottom: 0;
  right: 0;
}
.leftTop {
  position: absolute;
  font-size: var(--fonts11);
  text-align: start;
  bottom: 0;
  left: 0;
}
.printName {
  margin-top: 10px;
  border-bottom: 1px solid #6D6D6D;
  width: fit-content;
  margin-inline: auto;
  text-align: center;
  font-size: var(--fonts16);
  line-height: 1em;
}
.printTitle {
  text-align: center;
  font-size: var(--fonts18);
  letter-spacing: .03em;
  line-height: 1em;
}
.header {
  /* border: 1px solid #CACACA; */
  position: relative;
}
span.typeHighlight {
  font-weight: 700;
}
span.space {
  margin-left: 1em;
}
span.Bigger {
  font-size: var(--fonts14)
}
  `
}
